import type { FiltrosDrilldown } from '@baiocchi/shared'

/**
 * Converte o `drilldown` que o servidor devolveu em uma URL da lista de leads.
 *
 * O contrato manda cada bloco do dashboard devolver **os filtros prontos para
 * `GET /leads`** (`03-endpoints-draft.md §9`, última linha). A tela só monta a
 * query string: se ela remontasse o filtro por conta própria, o número do card e o
 * total da lista divergiriam no primeiro ajuste de regra — e a conversa "o
 * dashboard diz 216 e a lista traz 203" é a mais cara que existe em operação.
 *
 * O **escopo** do usuário não vai no drill-down, de propósito: é reaplicado pela
 * listagem no servidor. Mandá-lo seria convidar o cliente a alterá-lo.
 */
export function urlDoDrilldown(drilldown: FiltrosDrilldown | undefined, base = '/leads'): string {
  if (!drilldown) return base
  const busca = new URLSearchParams()
  for (const [chave, valor] of Object.entries(drilldown)) {
    if (valor === null || valor === undefined || valor === '') continue
    busca.set(chave, String(valor))
  }
  const texto = busca.toString()
  return texto ? `${base}?${texto}` : base
}
